<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https:farmbusinessapp.org"
        target="_blank"
      >Farmbusiness</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="float-md-right d-none d-md-block">
      <b-avatar
        style="background-color: transparent !important;"
        src="/logo.png"
      />
    </span>
  </p>
</template>

<script>
import { BLink, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BAvatar,
  },
}
</script>
